import type { VoiceClonerNotificationStatus } from '../types/domain';
import { USE_MOCK_API } from '../config';
import { http } from './http';
import { assertMock, mockDelay } from './mock';

let mockSubscribed = false;

export const voiceClonerApi = {
  async getNotificationStatus(): Promise<VoiceClonerNotificationStatus> {
    if (!USE_MOCK_API) {
      return http.get<VoiceClonerNotificationStatus>('/voice-cloner/notification');
    }
    assertMock('voiceClonerApi.getNotificationStatus');
    return mockDelay({ subscribed: mockSubscribed });
  },

  async subscribe(): Promise<VoiceClonerNotificationStatus> {
    if (!USE_MOCK_API) {
      return http.post<VoiceClonerNotificationStatus>('/voice-cloner/notification');
    }
    assertMock('voiceClonerApi.subscribe');
    mockSubscribed = true;
    return mockDelay({ subscribed: true });
  },
};
